import type { FC } from 'react';

const Footer: FC = () => (
  <footer id="footer" className="bg-foreground-950 text-white">
    <div className="section-container py-12 md:py-16">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
        <div className="sm:col-span-2 lg:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-flower-line text-lg text-white"></i>
            </div>
            <span className="text-xl font-bold font-heading tracking-wide">91樱花</span>
          </div>
          <p className="text-sm text-white/50 leading-relaxed max-w-xs">
            91樱花网提供最新动漫资源一站式入口，覆盖2026夏季新番、经典老番、国漫精选与剧场版动画。永久域名防封地址，确保你的安全稳定访问。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
          <nav className="flex flex-col gap-2">
            <a href="#hero" className="text-sm text-white/50 hover:text-primary-400 transition-colors">首页</a>
            <a href="#ranking" className="text-sm text-white/50 hover:text-primary-400 transition-colors">热门榜单</a>
            <a href="#cards" className="text-sm text-white/50 hover:text-primary-400 transition-colors">精选推荐</a>
            <a href="#carousel" className="text-sm text-white/50 hover:text-primary-400 transition-colors">焦点专题</a>
            <a href="#faq" className="text-sm text-white/50 hover:text-primary-400 transition-colors">常见问题</a>
          </nav>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-white mb-4">动漫分类</h4>
          <nav className="flex flex-col gap-2">
            <a href="#index" className="text-sm text-white/50 hover:text-accent-400 transition-colors">2026夏季新番</a>
            <a href="#index" className="text-sm text-white/50 hover:text-accent-400 transition-colors">热血冒险</a>
            <a href="#index" className="text-sm text-white/50 hover:text-accent-400 transition-colors">恋爱日常</a>
            <a href="#index" className="text-sm text-white/50 hover:text-accent-400 transition-colors">奇幻异世界</a>
            <a href="#index" className="text-sm text-white/50 hover:text-accent-400 transition-colors">国漫精选</a>
          </nav>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-white mb-4">合作伙伴</h4>
          <p className="text-sm text-white/35 leading-relaxed">
            感谢所有支持91樱花的合作伙伴与动漫爱好者社区。携手同行，共创更好的动漫观看体验。
          </p>
          <div className="mt-4 flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10 text-white/50 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
              <i className="ri-weibo-line text-sm"></i>
            </div>
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10 text-white/50 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
              <i className="ri-bilibili-line text-sm"></i>
            </div>
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10 text-white/50 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
              <i className="ri-mail-line text-sm"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-white/35">
          &copy; 2026 91樱花网 - 91樱花网站首页入口 | 永久域名防封地址安全访问
        </p>
        <p className="text-xs text-white/25">
          本站内容仅供动漫爱好者交流学习使用
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;